module.exports = "/images/cover-6.jpg";